export default {
  options: {
    none: 'Nessun codice promozionale per iniziare',
  },
  buttons: {
    next: 'Avanti',
    back: 'Indietro',
    skip: 'Salta',
  },
};
